import React from "react";
import { Container } from "react-bootstrap";

const AssemblyBoardEditScreen = () => {
  <Container
    className="d-flex justify-content-center align-items-center"
    style={{ height: "80vh" }}
  >
    <h2 className="text-primary">🛠️ Feature Under Development 😊</h2>
  </Container>;
};

export default AssemblyBoardEditScreen;
